<template>
  <div>
    <material-card
      :title="title"
      :color="$vuetify.theme.themes.light.success"
      icon="add"
    >
      <v-card-text v-if="item">
        <v-form ref="form" v-model="valid" style="margin-top: 10px">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <pbas-date-picker
                  :label="$t('headers.selfpayments.payment_date')"
                  :value="item.PaymentDate"
                  @update-date="item.PaymentDate = $event"
                  :rules="[$rules.required]"
                  :class="'required'"
                ></pbas-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :value="item.Term"
                  @change="updateTerm"
                  :items="terms"
                  :label="$t('headers.selfpayments.plan_term')"
                  item-value="Id"
                  :item-text="(item) => `${trans2(item, 'FullName')}`"
                  :rules="[$rules.required]"
                  class="required"
                  return-object
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="conditions !== null && conditions !== undefined">
              <v-col cols="12" md="6">
                <v-select
                  v-model="item.SelfPaymentCondition"
                  :items="conditions"
                  :label="$t('globals.amount')"
                  item-value="Id"
                  :item-text="conditionText"
                  :rules="[$rules.required]"
                  class="required"
                  return-object
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  :label="$t('headers.selfpayments.deposited')"
                  v-model="item.Deposited"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="6">
                <trans-enum
                  :value.sync="item.Type"
                  :items="options.Enums.PaymentType"
                  :label="$t('globals.type')"
                  class="required"
                  :rules="[$rules.required]"
                ></trans-enum>
              </v-col>
              <v-col cols="12" md="6">
                <no-autocomplete-textfield
                  :label="$t('views.planbalance.cheque_number')"
                  @change="item.PaymentNumber = $event"
                  :value="item.PaymentNumber"
                ></no-autocomplete-textfield>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <auto-select
                  :value.sync="item.Category"
                  :label="$t('globals.category')"
                  :items="categories"
                  :rules="[$rules.required]"
                  class="required"
                />
              </v-col> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn
          :disabled="!valid || disabled"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransSelect2 from "../components/TransSelect2";
import { translate2 } from "../trans2";
import TransEnum from "../components/TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect2,
    TransEnum,
  },
  props: ["item", "title", "memberIdentityId", "eligibilityBankId"],
  data() {
    return {
      valid: true,
      error: null,
      saving: false,
      terms: [],
      disabled: true,
      member: null,
      selfPaymentSettings: null,
      conditions: null,
      formatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      }),
      coverages: [],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
  },
  watch: {
    "item.PaymentDate": {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.loadEmployerAndTerms(v);
        }
      },
    },
  },
  async mounted() {
    // if (this.item.PaymentDate!==null && this.item.PaymentDate !== undefined) {
    //   await this.loadEmployerAndTerms(this.item.PaymentDate);
    //   let term = this.terms.filter(o=>o.CalendarYear === this.item.CalendarYear && o.CalendarMonth === this.item.CalendarMonth)
    //   if (term.length > 0) {
    //     this.item.Term = term[0];
    //   }
    // }
  },
  methods: {
    ...mapActions("plansMembers", [
      "addMemberSelfPayments",
      "getMemberByEffectiveDate",
      "getEmployerContributionTerms",
      "getMemberEligibilityBank",
      "getContributionPlan",
      "getPlanSelfPaymentSettings",
      "getCoverageByEffectiveDate",
      "validateMemberEligibilityBankBalance",
      "updateMemberSelfPayment"
    ]),
    trans2(item, property) {
      return translate2(item, property);
    },
    async updateTerm(v) {
      console.log(
        "term: ",
        v,
        this.planIdentity.HasEligibilityBank,
        this.eligibilityBankId,
        this.planIdentity.Deductible
      );
      if (v !== null && v != undefined) {
        this.item.Term = v;
        if (this.planIdentity.HasEligibilityBank) {
          await this.validateBalance(v.CalendarYear, v.CalendarMonth);
        }
      }
    },
    async save() {
      this.error = null;
      this.saving = true;
      try {
        console.log(this.item);
        let item = JSON.parse(JSON.stringify(this.item));
        if (item.Term) {
          item.CalendarMonth = item.Term.CalendarMonth;
          item.CalendarYear = item.Term.CalendarYear;
          delete item.Term;
        }
        if (item.SelfPaymentCondition) {
          console.log(item.SelfPaymentCondition);
          item.Amount = parseFloat(item.SelfPaymentCondition.Rate); //.toFixed(2);
          item.SelfPaymentConditionId = item.SelfPaymentCondition.Id;
          delete item.SelfPaymentCondition;
        }

        if (item.Id) {
          delete item["@odata.context"];
          await this.updateMemberSelfPayment({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: item.MemberIdentityId,
            id: item.Id,
            payload: item,
          });
        } else {
          item.CreatedAt = this.$helpers.nowFormatted();

          await this.addMemberSelfPayments({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: item.MemberIdentityId,
            payload: item,
          });
        }
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
      }
    },
    async loadEmployerAndTerms(effectiveDate) {
      try {
        this.loading = true;
        this.member = (
          await this.getMemberByEffectiveDate({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.memberIdentityId,
            effectiveDate: effectiveDate,
            odataQuery:
              "$select=Id,CurrentYearsOfContinuousEmployment,&$expand=CurrentMember($select=DateOfBirth),CurrentEmploymentInformation($select=EmployerId,HireDate),CurrentMembershipStatus($select=MemberGroupIdentityId)",
          })
        ).data;
        let employerId = this.member.CurrentEmploymentInformation.EmployerId;
        let terms = (
          await this.getEmployerContributionTerms({
            planIdentityId: this.selectedPlan.Id,
            employerId: employerId,
          })
        ).data.value;
        this.terms = terms.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.CalendarMonth === value.CalendarMonth &&
                t.CalendarYear === value.CalendarYear
            )
        );
        if (
          this.item.CalendarYear !== null &&
          this.item.CalendarYear !== undefined &&
          this.item.CalendarMonth !== null &&
          this.item.CalendarMonth !== undefined
        ) {
          let term = this.terms.filter(
            (o) =>
              o.CalendarYear === this.item.CalendarYear &&
              o.CalendarMonth === this.item.CalendarMonth
          );
          console.log(term);
          if (term.length > 0) {
            this.updateTerm(term[0]);
          }
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async validateBalance(calendarYear, calendarMonth) {
      if (
        this.eligibilityBankId !== null &&
        this.eligibilityBankId !== undefined
      ) {
        try {
          this.loading = true;

          let query =
            "$expand=Translations($select=LanguageCode,Name,Description)&$select=IdentityId";
          let month = calendarMonth.toString();
          if (calendarMonth < 10) {
            month = `0${calendarMonth}`;
          }
          let effectiveDate = `${calendarYear}-${month}-01`;
          this.coverages = (
            await this.getCoverageByEffectiveDate({
              planIdentityId: this.planIdentity.Id,
              effectiveDate: effectiveDate,
              query: query,
            })
          ).data.value;

          let termYear = calendarYear;
          let yearsOfEmployment =
            this.member.CurrentYearsOfContinuousEmployment;
          //termYear - this.member.CurrentEmploymentInformation.HireDate.split("-")[0];
          const [dobDate, dobTime] =
            this.member.CurrentMember.DateOfBirth.split("T");
          const [dobYear, dobMonth, dobDay] = dobDate.split("-");
          let age = termYear - dobYear - (dobMonth > 1 ? 1 : 0);
          let selfPaymentId = null;
          if (this.item != null && this.item !== undefined) {
            selfPaymentId = this.item.Id;
          }
          this.conditions = (
            await this.validateMemberEligibilityBankBalance({
              planIdentityId: this.planIdentity.Id,
              memberIdentityId: this.memberIdentityId,
              payload: {
                EligibilityBankId: this.eligibilityBankId,
                CalendarYear: calendarYear,
                CalendarMonth: calendarMonth,
                YearsOfEmployment: yearsOfEmployment,
                Age: age,
                SelfPaymentId: selfPaymentId,
              },
            })
          ).data;

          this.disabled = false;
        } catch (error) {
          this.disabled = true;
          this.error = error;
        } finally {
          this.loading = false;
        }
      }
    },
    conditionText(condition) {
      var stringBuilder = [];
      var coverageStr = this.coverages
        .filter((o) => condition.CoverageIdentityIds.indexOf(o.IdentityId) > -1)
        .map((o) => translate2(o, "Name"))
        .join(", ");
      stringBuilder.push(this.formatter.format(condition.Rate));
      if (
        condition.MinimumYearsOfEmploymentIncluding !== null &&
        condition.MinimumYearsOfEmploymentIncluding !== undefined
      ) {
        if (
          condition.MaximumYearsOfEmploymentExcluding !== null &&
          condition.MaximumYearsOfEmploymentExcluding !== undefined
        ) {
          stringBuilder.push(`${condition.MinimumYearsOfEmploymentIncluding} <= Years of Employment < ${condition.MaximumYearsOfEmploymentExcluding}`);
          stringBuilder.push(`${coverageStr}`);
        } else {
          stringBuilder.push(`${condition.MinimumYearsOfEmploymentIncluding} <= Years of Employment`);
          stringBuilder.push(`${coverageStr}`);
        }
      } else {
        if (
          condition.MaximumYearsOfEmploymentExcluding !== null &&
          condition.MaximumYearsOfEmploymentExcluding !== undefined
        ) {
          stringBuilder.push(`Years of Employment < ${condition.MaximumYearsOfEmploymentExcluding}`);
          stringBuilder.push(`${coverageStr}`);
        }
      }
      if (
        condition.MinimumAgeIncluding !== null &&
        condition.MinimumAgeIncluding !== undefined
      ) {
        if (
          condition.MaximumAgeExcluding !== null &&
          condition.MaximumAgeExcluding !== undefined
        ) {
          if (stringBuilder.indexOf(coverageStr) == -1) {
            stringBuilder.push(`${condition.MinimumAgeIncluding} <= Age < ${condition.MaximumAgeExcluding}`);
            stringBuilder.push(`${coverageStr}`);
          } else {
            stringBuilder.splice(stringBuilder.indexOf(coverageStr)-1,0,`${condition.MinimumAgeIncluding} <= Age < ${condition.MaximumAgeExcluding}`);
          }
        } else {
          if (stringBuilder.indexOf(coverageStr) == -1) {
            stringBuilder.push(`${condition.MinimumAgeIncluding} <= Age`);
            stringBuilder.push(`${coverageStr}`);
          } else {
            stringBuilder.splice(stringBuilder.indexOf(coverageStr)-1,0,`${condition.MinimumAgeIncluding} <= Age`);
          }
        }
      } else {
        if (
          condition.MaximumAgeExcluding !== null &&
          condition.MaximumAgeExcluding !== undefined
        ) {
          if (stringBuilder.indexOf(coverageStr) == -1) {
            stringBuilder.push(`Age < ${condition.MaximumAgeExcluding}`);
            stringBuilder.push(`${coverageStr}`);
          } else {
            stringBuilder.splice(stringBuilder.indexOf(coverageStr)-1,0,`Age < ${condition.MaximumAgeExcluding}`);
          }
        }
      }
      return stringBuilder.join("-");
    },
  },
};
</script>
